import axios from "axios";
import { baseUrl } from "../../utils/baseUrl";

export const propertyListApi = async (
  keyword = "",
  propertyType,
  type,
  location,
  bedroom,
  bathroom,
  amenities,
  area_sqft,
  isFeatured,
  page
) => {
  try {
    const response = await axios.get(
      `${baseUrl}property-list?type=${type}&keyword=${keyword}&property_type=${propertyType}&location_id=${location}&badroom=${bedroom}&bathroom=${bathroom}&area_sqft=${area_sqft}&amenities=${amenities}&is_featured=${isFeatured}&page=${page}`
    );
    return response;
  } catch (error) {
    return null;
  } finally {
  }
};

export const categoryListApi = async () => {
  try {
    const response = await axios.get(`${baseUrl}category-list`);
    return response;
  } catch (error) {
    return null;
  } finally {
  }
};
